<template>
  <div id="color" class="flex_color">
    <div class="color_title text_size_middle bold">{{title}}</div>
    <div class="color_name">{{color.name}}</div>
    <div class="color_img">
      <img v-if="color.imgB !== undefined" :src="color.imgB">
    </div>
  </div>
</template>
<script>
// Module

export default {
  name: 'Color',
  components: {
  },
  props: {
    title: String,
    color: Object
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style src="../../../../css/dcstyle.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-common.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/input/color/DcColorForCart.vue